var $a48782afe17e416a$exports = {};
$a48782afe17e416a$exports = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};


export {$a48782afe17e416a$exports as default};
//# sourceMappingURL=de-DE.mjs.map
